import React from 'react';

import LoadingIcon from '../../assets/images/bnplLoading.gif';

export default function BnplLoading({ className, isAuth = false }) {
  return (
    <div className={`${className}__loading`}>
      {!isAuth && <h3>Processing your Application</h3>}
      <div className={`${className}__loading__image`}>
        <img src={LoadingIcon} alt="loading" />
      </div>
    </div>
  );
}
